var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#F0E5CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25452 7.89596C6.25452 7.46059 6.42747 7.04305 6.73532 6.7352C7.04317 6.42734 7.46071 6.25439 7.89608 6.25439H8.64682C9.1174 6.25439 9.52779 6.57505 9.64215 7.0314L10.2468 9.45161C10.2958 9.6475 10.2859 9.8535 10.2183 10.0438C10.1508 10.2341 10.0286 10.4002 9.86705 10.5214L9.15953 11.0521C9.08566 11.1074 9.0698 11.1884 9.09059 11.2447C9.39941 12.0846 9.88707 12.8473 10.5198 13.48C11.1526 14.1128 11.9153 14.6004 12.7551 14.9093C12.8115 14.93 12.8919 14.9142 12.9477 14.8403L13.4785 14.1328C13.5996 13.9713 13.7658 13.8491 13.9561 13.7815C14.1463 13.7139 14.3523 13.7041 14.5482 13.753L16.9684 14.3577C17.4248 14.4721 17.7454 14.8824 17.7454 15.3536V16.1038C17.7454 16.5391 17.5725 16.9567 17.2646 17.2645C16.9568 17.5724 16.5393 17.7453 16.1039 17.7453H14.8727C10.1133 17.7453 6.25452 13.8866 6.25452 9.12713V7.89596Z",
    fill: "#CE6605"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contactPhone.f794c468f747212eff346e3c0deb74c7.svg";
export { ForwardRef as ReactComponent };